import React , { Component } from 'react';
import {injectIntl} from 'react-intl';
import { toggleHelp } from '../../actions';

import TetherComponemt from 'react-tether';
import ReactMarkdown from 'react-markdown';

class Help extends Component {
  constructor(props) {
    super(props);

    this.onOverHandler=this.onOverHandler.bind(this);
    this.handler=this.handler.bind(this);
    this.state = {
      visible: false,
      selected: false
    }
  }

  handler() {

    toggleHelp();

    this.setState({selected:!this.state.selected});
  }

  onOverHandler(visible) {

    this.setState({visible: visible});
  }

  render() {
    const { formatMessage } = this.props.intl;

    let desc = formatMessage({id:'helpGuide'});
    let mdGuide = <ReactMarkdown source={desc}/>;

    let color = (this.state.selected?'#93ff3d':'white');
    let effects = this.state.selected && '0 0 10px #fff, 0 0 20px #fff, 0 0 10px #fff, 0 0 15px #93ff3d';
    return (
     <ul className="nav navbar-nav navbar-right" style={ { marginRight:'20px', marginTop:'12px'}}>
	    <li>
        <div>
        <TetherComponemt attachment="top right"
          targetAttachment="bottom right"
          renderElementTo="#mainHelpButton"
          style={{
            padding:'10px',
            opacity: '0.99',
            color: '#fff',
            background:'rgb(105,105,105)',
            //background:'#fff',
            zIndex:'1030'
          }}>

          <a id="mainHelpButton" onClick={this.handler} style={{cursor:'pointer', color:color, textShadow:effects}}
             onMouseOver={this.onOverHandler.bind(this, true)}
             onMouseLeave={this.onOverHandler.bind(this,false)}>
            <i className="fa fa-question-circle-o" style={{fontSize:'200%'}}></i>
          </a>

          {this.state.visible && mdGuide}

          </TetherComponemt>
        </div>
      </li>
	    </ul>
    )
  }

}

export default injectIntl(Help);



// WEBPACK FOOTER //
// ./src/components/Header/Help.js